import { createContext } from "react";
import { LoadingOutlined } from "@ant-design/icons";

export const ADMIN_LAYOUT = {
  LOGO: {
    height: "36px",
    padding: "60px 40px 30px",
  },
  SUBTITLE: {
    fontSize: "22px",
  },
  CONTENT: {
    padding: "60px 60px",
  },
  MAXWIDTH: 800,
};

export const PASSWORD_STRONG = new RegExp(
  "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
);
export const PASSWORD_MEDIUM = new RegExp(
  "((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,}))|(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|((?=.*[a-z])(?=.*[A-Z])(?=.{8,}))"
);

export const STORAGE_KEY_REDIRECT = "kinetica_saas_redirect";
export const STORAGE_KEY_TEAM = "kinetica_saas_team";

// Shared min-height for the Login/Signup form columns. Both tabs render to
// the same height so the social-login buttons don't shift when switching.
// Sized to fit the taller (signup) form's natural content.
export const AUTH_FORM_MIN_HEIGHT = 490;

export const AlertContext = createContext();

export const Spinner = <LoadingOutlined style={{ fontSize: 48 }} spin />;

export const SERVICE_LEVEL = {
  FREE_SHARED: "free_shared",
  DEDICATED: "paid_hourly",
};

// Dark-mode-friendly accent palette (lightness >= 70% — readable on
// surface[100]/surface[200] backgrounds without dropping below WCAG AA).
export const COLORS = [
  "#ff5c8a", // pink (accent-400)
  "#f472b6", // rose
  "#a78bfa", // violet (brand-400)
  "#c4b5fd", // light violet (brand-300)
  "#818cf8", // indigo
  "#60a5fa", // blue
  "#67e8f9", // cyan
  "#5eead4", // teal
  "#6ee7b7", // emerald
  "#fcd34d", // amber
];

// Distinct hues per size so XS/S/M/L are instantly distinguishable at a
// glance. Drawn from the dark-mode COLORS palette above (all ≥70% lightness
// against surface[100]/surface[200]).
export const DEDICATED_SIZE_COLORS = {
  xsmall: COLORS[0], // pink
  small:  COLORS[2], // violet
  medium: COLORS[5], // blue
  large:  COLORS[6], // cyan
};
